module.exports = __webpack_public_path__ + "img/d52e7525-ac0e-40b2-bd01-3601c207e5bd.c25b1c4d.png";